/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createMultiplyScalar } from '../../factoriesAny.js';
export var multiplyScalarDependencies = {
  typedDependencies: typedDependencies,
  createMultiplyScalar: createMultiplyScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMultiplyScalar.generated.js
// module id = 47
// module chunks = 0